import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { style: {"text-align":"right","background-color":"#000000","width":"100%","height":"100%","position":"fixed"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_loading = _resolveComponent("loading")!
  const _component_qrcode_stream = _resolveComponent("qrcode-stream")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Button, {
      label: "Cancel scanning",
      icon: "pi pi-ban",
      class: "p-m-3",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.store.commit('setCameraScanMode', false)))
    }),
    _createVNode(_component_loading, {
      active: _ctx.camera_loading,
      opacity: 0,
      color: "#FFFFFF"
    }, null, 8, ["active"]),
    _createElementVNode("div", null, [
      _createVNode(_component_qrcode_stream, {
        style: {"width":"100%"},
        onDecode: _ctx.onDecode,
        onInit: _ctx.onInit
      }, null, 8, ["onDecode", "onInit"])
    ])
  ]))
}